import React, { useState, useEffect } from 'react';
import authService from './api-authorization/AuthorizeService';
import axios from 'axios';
import "bootstrap/dist/css/bootstrap.min.css";
import { ThreeDots } from "react-loader-spinner";
import MUIDataTable, { ExpandButton } from "mui-datatables";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import PGNViewer from './PGNViewer';
import Modal from '@mui/material/Modal';
import PreviewIcon from '@mui/icons-material/Preview';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import FormLabel from "@mui/material/FormLabel";
import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';

const muiCache = createCache({
    key: 'mui-datatables',
    prepend: true,
});

export default function PlayerGames(props) {
    const [status, setStatus] = useState();
    const [statusColor, setStatusColor] = useState();
    const [playerId, setPlayerId] = useState(props.playerId);
    const [idType, setIdType] = useState(props.idType);
    const [player, setPlayer] = useState(props.player);
    const [playerName, setPlayerName] = useState("");
    const [token, setToken] = useState();
    const [authenticated, setAuthenticated] = useState(false);
    const [waiting, setWaiting] = useState(false);
    const [games, setGames] = useState([]);
    const [gamePGNString, setGamePGNString] = useState([]);
    const [gameKey, setGameKey] = useState("");
    const [open, setOpen] = useState(false);
    const [searching, setSearching] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [tokenCount, setTokenCount] = useState(0);
    const [includeGamesOfSameName, setIncludeGamesOfSameName] = useState(false);
    const [excludeBlitzGames, setExcludeBlitzGames] = useState(false);
    
    const columns = [
        {
            name: '',
            label: '',
            options: {
                filter: false,
                display: true,
                viewColumns: false,
                setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "center", whiteSpace: "nowrap", width: "60px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, update) => {
                    let rowIndex = Number(tableMeta.rowIndex) + 1;
                    return (
                        <div style={{ textAlign: "right" }}><span>{rowIndex}</span></div>
                    )
                }
            },
        },
        {
            name: 'year',
            label: 'Year',
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true,
                setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "center", whiteSpace: "nowrap", width: "60px" }}>
                        {columnMeta.label}
                    </th>
                ),
            },
        },
        {
            name: 'month',
            label: 'Month',
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true,
                setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "center", whiteSpace: "nowrap", width: "60px" }}>
                        {columnMeta.label}
                    </th>
                ),
            },
        },
        {
            name: 'day',
            label: 'Day',
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: false,
                viewColumns: true,
                setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "center", whiteSpace: "nowrap", width: "60px" }}>
                        {columnMeta.label}
                    </th>
                ),
            },
        },

        {
            name: "date",
            label: "Date",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left" } }),
                //setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left" } }),
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "center", whiteSpace: "nowrap", width: "60px" }}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let game = games[originalIndex];
                    let dateStr = (game.year != null ? game.year.toString().padStart(4, '0') : "0000") + "-" + (game.month != null ? game.month.toString().padStart(2, '0') : "01") + "-" + (game.day != null ? game.day.toString().padStart(2, '0') : "01");

                    return (
                        <div style={{ textAlign: "left" }}> {dateStr}</div>
                    );
                },
                sortCompare: (order) => {
                    return (obj1, obj2) => {
                        let val1 = Date.parse(obj1.data);
                        let val2 = Date.parse(obj2.data);
                        return (val1 - val2) * (order === 'asc' ? 1 : -1);
                    };
                }
            }
        },
        {
            name: "event",
            label: "Event",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                /*setCellProps: () => ({ style: { whiteSpace: "nowrap", width: "200px" } }),*/
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "center", whiteSpace: "nowrap"}}>
                        {columnMeta.label}
                    </th>
                ),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                    };
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let game = games[originalIndex];
                    return (
                        <div style={{ position: "relative", height: "20px", width:"200px"}}>
                            <div style={parentStyle}>
                                <div style={cellStyle} title={value}>
                                    {game.uscfEventId != -1 ? (<a href={'http://www.uschess.org/msa/XtblMain.php?' + game.uscfEventId} target='_blank' rel='noreferrer'>{value}</a>) :
                                        (game.fideEventId != -1 ? (<a href={'https://ratings.fide.com/report.phtml?event=' + game.fideEventId} target='_blank' rel='noreferrer'>{value}</a>) : value)}
                                </div>
                            </div>
                        </div>
                    );
                  }
            }
        },
        {
            name: "whiteElo",
            label: "WElo",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                /*setCellProps: () => ({ style: { whiteSpace: "nowrap", width: "40px" } }),*/
                setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left" } }),
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <div key={2} onClick={() => updateDirection(2)} style={{ textAlign: "right", whiteSpace: "nowrap", width: "40px" }}>
                        {columnMeta.label}
                    </div>
                ),
            }
        },
        {
            name: "white",
            label: "White",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "100px" }}>
                        {columnMeta.label}
                    </th>
                    ),
                //setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "right", minWidth: "100px", maxWidth:"100px", overflow: "hidden", textOverflow: "ellipsis",} }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let game = games[originalIndex];
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left",
                    };
                    
                    return (
                        <div style={{ position: "relative", height: "20px", width:"120px" }} title={value}>
                              <div style={parentStyle}>
                                <div style={cellStyle} title={value}>{game.whiteUSCFID != -1 ? (<a href={'https://ratings.uschess.org/player/' + game.whiteUSCFID} target='_blank' rel='noreferrer'>{value}</a>) :
                                    (game.whiteFIDEID != -1 ? (<a href={'https://ratings.fide.com/profile/' + game.whiteFIDEID} target='_blank' rel='noreferrer'>{value}</a>): value)}</div>
                              </div>
                          </div>
                    );
                }
            }
        },
        {
            name: "result",
            label: "Result",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th style={{ textAlign: "left", whiteSpace: "nowrap", width: "20px" }}>
                        {columnMeta.label}
                    </th>
                ),
                setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left" } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    if (authenticated) {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let game = games[originalIndex];
                        return (
                            <div style={{ textAlign: "left" }} onClick={async (e) => { await viewGame(e, game.gameHash) }}> <PreviewIcon />{value}</div>
                        );
                    }
                    else {
                        return (
                            <div style={{ textAlign: "center" }}> {value}</div>
                        );
                    }
                    
                }
            }
        },
        {
            name: "black",
            label: "Black",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "100px" }}>
                        {columnMeta.label}
                    </th>
                ),
                //setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left", minWidth: "100px", maxWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", boxSizing: "border-box", } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                    let parentStyle = {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        boxSizing: "border-box",
                        display: "block",
                        width: "100%"
                    };
                    let cellStyle = {
                        boxSizing: "border-box",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "left"
                    };
                    let game = games[originalIndex];
                    return (
                        <div style={{ position: "relative", height: "20px", width:"120px"}} title={value}>
                            <div style={parentStyle}>
                        <div title={value} style={cellStyle}>
                                    {game.blackUSCFID != -1 ? (<a href={'https://ratings.uschess.org/player/' + game.blackUSCFID} target='_blank' rel='noreferrer'>{value}</a>) :
                                        (game.blackFIDEID != -1 ? (<a href={'https://ratings.fide.com/profile/' + game.blackFIDEID} target='_blank' rel='noreferrer'>{value}</a>) : value)}
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
            name: "blackElo",
            label: "BElo",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left"} }),
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap", width: "20px" }}>
                        {columnMeta.label}
                    </th>
                ),
            }
        },
        {
            name: "plyCount",
            label: "PlyCount",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                sortThirdClickReset: true,
                display: true,
                viewColumns: true,
                setCellProps: () => ({ style: { whiteSpace: "nowrap", textAlign: "left" } }),
                customLabelHeadRender: (columnMeta, updateDirection) => (
                    <th key={2} onClick={() => updateDirection(2)} style={{ textAlign: "left", whiteSpace: "nowrap" }}>
                        {columnMeta.label}
                    </th>
                )
            }
        }
    ];

    const options = {
        draggableColumns: {
            enabled: true
        },
        fixedHeader: true,
        resizableColumns: true,
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        selectableRows: 'none',
        download: false,
        print: false,
        rowsPerPage: [10],
        rowsPerPageOptions: [5, 10, 15, 25, 50, 100, 200],
        jumpToPage: true,
        expandableRows: false,
        expandableRowsOnClick: true,
        expandableRowsHeader: true,
        isRowExpandable: (dataIndex, expandedRows) => {
            // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
            if (expandedRows.data.length > 4 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
                return false;
            return true;
        },
        rowsExpanded: [],
        onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
            console.log(curExpanded, allExpanded, rowsExpanded),
    };

    const theme = createTheme({
        overrides: {
            MUIDataTableSelectCell: {
                expandDisabled: {
                    // Soft hide the button.
                    visibility: 'hidden',
                },
            },
        },
    });

    const components = {
        ExpandButton: function (props) {
            return <ExpandButton {...props} />;
        },
    };

    useEffect(async () => {
        setAuthenticated(await authService.isAuthenticated());
        var ttt = await authService.getAccessToken();
        //await setToken(await authService.getAccessToken());
        await setToken(ttt);
        if (props.includeGamesOfSameName) {
         await setIncludeGamesOfSameName(true);
        }
        if (props.excludeBlitzGames) {
            await setExcludeBlitzGames(true);
        }
        if (Object.keys(player).length != 0) {
            player.fidePlayerId > 0 ? setPlayerName(player.fideName) : (player.uscfPlayerId > 0 ? setPlayerName(player.uscfName) : setPlayerName(""))
        } else {
            setPlayerName("")
        }
        if (props.player.fidePlayerId > 0) {
            setIdType("FIDE");
            setPlayerId(props.player.fidePlayerId);
            findPlayerGames("FIDE", props.player.fidePlayerId, ttt, props.includeGamesOfSameName, props.excludeBlitzGames )
        }
        else {
            setIdType("USCF");
            setPlayerId(props.player.uscfPlayerId);
            findPlayerGames("USCF", props.player.uscfPlayerId, ttt, props.includeGamesOfSameName, props.excludeBlitzGames)
        }

    }, []); //Runs only on the first render

    //https://stackoverflow.com/questions/41938718/how-to-download-files-using-axios?rq=1

    const downloadPGN = async (e, idType, id, includeGamesOfSameName, excludeBlitzGames) => {
        if (!id) {
            e.preventDefault();
            setStatusColor("red");
            setStatus("Error : No ID provided");
            setDownloading(false);
        }
        else {
            e.preventDefault();
            setToken(await authService.getAccessToken());
            var headers = {
                headers: { 'Authorization': `Bearer ${token}` }
            }
            setWaiting(true);
            axios.get('/api/ChessGames/downloadPGN?IDType=' + idType + '&id=' + id + '&includeGamesOfSameName=' + props.includeGamesOfSameName + '&excludeBlitzGames=' + props.excludeBlitzGames, headers).then((response) => {
                let responseHeader = response.headers['content-disposition'].split('filename=');
                let fileName = responseHeader[1].split(';')[0];
                let blob = new Blob([response.data]);
                let FileSaver = require('file-saver');
                FileSaver.saveAs(blob, fileName);
                setWaiting(false);
                setDownloading(false);
            }).catch((error) => {
                setDownloading(false);
                setWaiting(false);
                setStatus(error.response.data);
                console.log(error.response.data);
            });
        }

    };

    const emailPGN = async (e, idType, id, includeGamesOfSameName, excludeBlitzGames) => {
        if (!id) {
            e.preventDefault();
            setStatusColor("red");
            setStatus("Error : No ID provided");
            setDownloading(false);
        }
        else {
            e.preventDefault();
            setToken(await authService.getAccessToken());
            var headers = {
                headers: { 'Authorization': `Bearer ${token}` }
            }
            setWaiting(true);
            axios.get('/api/ChessGames/emailPGN?IDType=' + idType + '&id=' + id + '&includeGamesOfSameName=' + props.includeGamesOfSameName + '&excludeBlitzGames=' + props.excludeBlitzGames, headers).then((response) => {
                setStatus(response.data);
                setWaiting(false);
                setDownloading(false);
            }).catch((error) => {
                setDownloading(false);
                setWaiting(false);
                setStatus(error.response.data);
                console.log(error.response.data);
            });
        }

    };

    const findPlayerGames = async (idType, id, accessToken, includeGamesOfSameName, excludeBlitzGames) => {
        if (!id) {
            //e.preventDefault();
            setStatusColor("red");
            setStatus("Error : No ID provided");
            setSearching(false);
        }
        else {
            //e.preventDefault();
            //setWaiting(true);
            //setToken(await authService.getAccessToken());
            var headers = {
                headers: { 'Authorization': `Bearer ${accessToken}` }
            }

            axios.get('/api/chessgames/findplayergames?idtype=' + idType + '&id=' + id + '&includeGamesOfSameName=' + includeGamesOfSameName + '&excludeBlitzGames='+excludeBlitzGames, headers).then((response) => {
                const playergames = response.data;
                setSearching(false);
                setGames(playergames);
                if (playergames.length > 0) {
                    setStatusColor("green");
                } else {
                    setStatusColor("red");
                }
                
                setWaiting(false);
                setStatus(playergames.length + " games for "
                    + props.player.fideTitle + " "
                    + (props.player.fidePlayerId > 0 ? props.player.fideName : props.player.uscfName)
                    + (props.player.fidePlayerId > 0 ? " [" + props.player.fideCountry + " FIDE " + props.player.fideRating + "]" : " ")
                    + (props.player.uscfPlayerId > 0 ? " [" + props.player.uscfState + " USCF " + props.player.uscfRating + "]" : " ")
                );
            }).catch((error) => {
                setStatusColor("red");
                setSearching(false);
                setStatus(error.response.data);
                setWaiting(false);
                console.log(error.response.data);
            });
            
        }
    };

    async function viewGame(e, gameHash) {
        e.preventDefault();
        var headers = {
            headers: { 'Authorization': `Bearer ${token}` }
        }
        setWaiting(true);
        await axios.get('/api/chessgames/getSingleGame?gamehash=' + gameHash, headers).then((response) => {
            const pgnString = response.data;
            setGamePGNString(pgnString);
            setGameKey(gameHash);
            setWaiting(false);
            setOpen(true);
        }).catch((error) => {
            setWaiting(true);
            setStatus(error.response.data);
            console.log(error.response.data);
        });
    };
    
    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    return (
        <Box sx={{ pt: 2, pb: 1 }}>
            <Grid container direction="row" rowSpacing={1} columnSpacing={1} justify-content="space-between" align-items="stretch">
            <Grid item xs={12} lg={7} >
                <FormLabel sx={{ color: statusColor }}>
                    {status}
                </FormLabel>
            </Grid>
                {games.length > 0 &&
                    <Grid item xs={4} lg={2} justifyContent="flex-end">
                        {authenticated &&
                            <LoadingButton
                                fullWidth
                                onClick={async (e) => { await setDownloading(true); await downloadPGN(e, idType, playerId); }}
                                loading={downloading}
                                loadingIndicator="Downloading..."
                                variant="contained"
                                endIcon={<CloudDownloadIcon/>}
                                >
                                Download
                            </LoadingButton>
                        }
                    </Grid>
                }
                {games.length > 0 &&
                    <Grid item xs={4} lg={2} justifyContent="flex-end">
                        {authenticated &&
                            <LoadingButton
                                fullWidth
                                onClick={async (e) => { await setDownloading(true); await emailPGN(e, idType, playerId); }}
                                loading={downloading}
                                loadingIndicator="Downloading..."
                                variant="contained"
                                color="secondary"
                                endIcon={<AttachEmailIcon/>}>
                                Email
                            </LoadingButton>
                        }
                    </Grid>
                }
                {games.length > 0 &&
                    <Grid item xs={4} lg={1} justifyContent="flex-end">
                    <Button endIcon={<ClearAllIcon/>}
                        fullWidth variant="outlined" disabled={playerId === null} onClick={async (e) => { e.preventDefault(); await setPlayer(); await setPlayerName(""); await setSearching(false); await setDownloading(false); await setPlayerId(""); await setStatus(""); await setGames([]) }}>
                        Clear
                    </Button>
            </Grid>
                }
            {waiting &&
                <Grid container xs={12}>
                    <div style={{ zIndex: 999, position: 'fixed', top: '30%', left: '50%' }}>
                        <span> <ThreeDots ariaLabel="waiting " color="#00BFFF" /></span>
                    </div>
                </Grid>
            }
            {games.length > 0 &&
                <Grid item xs={12}>
                        <CacheProvider value={muiCache}>
                            <ThemeProvider theme={theme}>
                                <MUIDataTable
                                    title={authenticated ? "" : "To download games, you must register & login"}
                                    data={games}
                                    columns={columns}
                                    options={options}
                                    components={components}
                                />
                            </ThemeProvider>
                        </CacheProvider>
                </Grid>
            }
               
        <Grid container xs={12}>
                <Modal style={{
                    "position": "fixed",
                    "bgcolor": "background.paper",
                    "boxShadow": "24",
                    "p": "4",
                    "alignItems": "center",
                    "justifyContent": "center",
                    display: 'flex',
                }}
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box style={{ "backgroundColor": "white", "padding": "10px" }}>
                        <div sytle={{ "alignItems": "right" }}>
                            <button className="btn btn-warning" onClick={handleClose}>Close</button>
                        </div>
                        <div>
                            <PGNViewer pgn={gamePGNString} key={gameKey} size={320} />
                        </div>
                    </Box>
                </Modal>
            </Grid>
            </Grid>
        </Box>
    )
}

